/**
 * The StorageAbstraction is meant to cover both storage abstractions defined in:
 *
 * app/gamma/src/util/application-storage/storage.ts
 * app/scripts/lib/storage-factory.coffee
 *
 * This should be deleted once we have a unified/shared storage strategy
 */
interface StorageAbstraction {
  enabled?: () => boolean;
  isEnabled?: () => boolean;
  set: (key: string, value: string | object) => void;
  // tslint:disable-next-line:no-any
  get: (key: string) => any;
  getRaw: (key: string) => string | null;
  unset: (key: string) => void;
}

/**
 * This function returns an object which takes a localStorage abstration as an
 * argument and returns an object which is functionally equivalent to the
 * LastOrganization singleton that was previously used. This should be rendered
 * obsolete as soon as we consolidate the storage abstractions in classic/gamma,
 * as we'd then be able to just call the abstraction's getters/setters for this.
 */
export default function lastOrganization(storage: StorageAbstraction) {
  const orgIdKey = 'idLastOrganization';
  const noOrgId = 'none';

  return {
    NO_ORGANIZATION: noOrgId,
    LAST_ORGANIZATION: orgIdKey,

    set(idOrganization: string): void {
      storage.set(orgIdKey, !!idOrganization ? idOrganization : noOrgId);
    },

    get(): string | null {
      const value = storage.get(orgIdKey);

      return typeof value === 'string' ? value : null;
    },
  };
}



// WEBPACK FOOTER //
// ./app/common/lib/util/last-organization.ts